module.exports = __webpack_public_path__ + "img/with_trophy.ce135ffc.png";